import { render, staticRenderFns } from "./SignatureAuthorize.vue?vue&type=template&id=72be921c&scoped=true&"
import script from "./SignatureAuthorize.vue?vue&type=script&lang=js&"
export * from "./SignatureAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./SignatureAuthorize.vue?vue&type=style&index=0&id=72be921c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be921c",
  null
  
)

export default component.exports